// extracted by mini-css-extract-plugin
module.exports = {"container":"c6e8ba5398--container--F3yyv","label":"c6e8ba5398--label--1afRc","title":"c6e8ba5398--title--_oKuW"};